import React, { useContext } from 'react'

import Context from '../../context'
import ClippingPartnersModal from '../ClippingPartnersModal'
import OffersSelector from '../OffersSelector'

const { REACT_APP_IMAGES_URL } = process.env

function SelectUnityToScriptsAndMoments() {
  const {
    fullPartnerList,
    setFullPartnerList,
    selectedPartnerList,
    setSelectedPartnerList,
    formObject,
    setFormObject,
    whiteLabels,
    user
  } = useContext(Context)

  const handleTextArea = (id, value) => {
    setSelectedPartnerList(list =>
      list.map(item => {
        if (item.id === id) {
          return { ...item, description: value }
        }
        return item
      })
    )
  }

  const getTextAreaValue = id => {
    const newObj = selectedPartnerList.find(item => item.id === id)

    return newObj ? newObj.description : ''
  }

  const removePartner = id => {
    setSelectedPartnerList(list => list.filter(item => item.id !== id))
  }

  return (
    <>
      {console.log(formObject)}
      <button
        type="button"
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#clippingPartnersModal"
      >
        Selecionar Locais:
      </button>
      {selectedPartnerList.map(item => (
        <div key={item.id} className="row" style={{ marginBottom: '15px' }}>
          <div className="col-2 d-flex justify-content-center align-items-center flex-column">
            <div
              style={{
                backgroundColor: 'gray',
                borderRadius: '5px',
                padding: '10px'
              }}
            >
              <img
                style={{ maxWidth: '150px' }}
                src={`${REACT_APP_IMAGES_URL}${item.logo}`}
                alt="logo"
              />
            </div>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginTop: '20px' }}
              onClick={() => removePartner(item.id)}
            >
              Remover
            </button>
          </div>
          <div className="col-10">
            <textarea
              rows="8"
              style={{ width: '100%' }}
              id={item.id}
              value={getTextAreaValue(item.id)}
              onChange={e => handleTextArea(item.id, e.target.value)}
              placeholder={`Descrição sobre ${item.fantasyName}`}
            />
          </div>
        </div>
      ))}
      <Context.Provider value={{ user, whiteLabels, formObject, setFormObject }}>
        <OffersSelector />
      </Context.Provider>
      <Context.Provider
        value={{
          selectedPartnerList,
          setSelectedPartnerList,
          fullPartnerList
        }}
      >
        <ClippingPartnersModal />
      </Context.Provider>
    </>
  )
}

export default SelectUnityToScriptsAndMoments
